import React from "react";
import PropTypes from "prop-types";

const TablePagination = ({ table, pagination, handlePageSizeChange }) => {
  return (
    <div
      style={{
        borderTop: "1px solid #dee2e6",
        padding: "5px 0",
        backgroundColor: "#f8f9fa",
        fontSize: "12px",
      }}
    >
      <nav>
        <ul className="pagination justify-content-center align-items-center m-0">
          <li
            className={`page-item ${
              !table.getCanPreviousPage() && "disabled"
            }`}
          >
            <button
              onClick={() => table.setPageIndex(0)}
              className="page-link py-1 px-2"
            >
              ⏮ First
            </button>
          </li>
          <li
            className={`page-item ${
              !table.getCanPreviousPage() && "disabled"
            }`}
          >
            <button
              onClick={() => table.previousPage()}
              className="page-link py-1 px-2"
            >
              ◀ Prev
            </button>
          </li>

          {/* Page Dropdown */}
          <li className="page-item active">
            <span className="page-link d-flex align-items-center py-1 px-2">
              <label htmlFor="page-select" className="me-1">
                Page
              </label>
              <select
                id="page-select"
                className="form-select form-select-sm mx-1"
                style={{
                  width: "65px",
                  height: "24px",
                  fontSize: "12px",
                }}
                value={pagination.pageIndex}
                onChange={(e) => table.setPageIndex(Number(e.target.value))}
              >
                {Array.from({ length: table.getPageCount() }, (_, index) => (
                  <option key={index} value={index}>
                    {index + 1}
                  </option>
                ))}
              </select>
              of {table.getPageCount()}
            </span>
          </li>

          <li
            className={`page-item ${!table.getCanNextPage() && "disabled"}`}
          >
            <button
              onClick={() => table.nextPage()}
              className="page-link"
              style={{ paddingTop: "4px", paddingBottom: "4px" }}
            >
              Next ▶
            </button>
          </li>
          <li
            className={`page-item ${!table.getCanNextPage() && "disabled"}`}
          >
            <button
              onClick={() => table.setPageIndex(table.getPageCount() - 1)}
              className="page-link"
              style={{ paddingTop: "4px", paddingBottom: "4px" }}
            >
              ⏭ Last
            </button>
          </li>

          {/* Rows per page */}
          <li className="ms-3 d-flex align-items-center">
            <label htmlFor="rows-per-page-select" className="me-2 mb-0">
              Rows per page:
            </label>
            <select
              id="rows-per-page-select"
              className="form-select form-select-sm"
              style={{ width: "70px" }}
              value={pagination.pageSize}
              onChange={handlePageSizeChange}
            >
              {[15, 20, 25, 50].map((size) => (
                <option key={size} value={size}>
                  {size}
                </option>
              ))}
            </select>
          </li>
        </ul>
      </nav>
    </div>
  );
};

TablePagination.propTypes = {
  table: PropTypes.shape({
    getCanPreviousPage: PropTypes.func.isRequired,
    setPageIndex: PropTypes.func.isRequired,
    previousPage: PropTypes.func.isRequired,
    getPageCount: PropTypes.func.isRequired,
    getCanNextPage: PropTypes.func.isRequired,
    nextPage: PropTypes.func.isRequired,
  }).isRequired,
  pagination: PropTypes.shape({
    pageIndex: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
  }).isRequired,
  handlePageSizeChange: PropTypes.func.isRequired,
};

export default TablePagination;